import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import TransitionedBlock from "../HelperComponents/TransitionedBlock/TransitionedBlock";
import Pagination from '../HelperComponents/Pagination/Pagination';
import ControlPanel from '../HelperComponents/ControlPanel/ControlPanel';
import WaitingReturnDispatchSuppliers from './WaitingReturnDispatchSuppliers/WaitingReturnDispatchSuppliers';

import RenderField from '../HelperComponents/RenderField/RenderField';
import { getReturnDispatchSuppliers, getReturnDispatchesDailySummary } from "../../actions/returnDispatchesActions";
import { formatPrice } from "../../helpers/functions";

import SearchIcon from "../../assets/image/search_grey.png";
import AddIcon from '../../assets/image/add.png';

import './ReturnDispatches.scss';

const today = new Date().toISOString().split("T")[0];

class ReturnDispatches extends Component {

    state = {
        activePage: 1,
        pageSize: 10,
        valueSearch: '',
        summaryDate: today,
    };

    componentDidMount = () => {
        this.doRequest();
        this.fetchDailySummary();
    };

    fetchDailySummary = () => {
        const { summaryDate } = this.state;
        this.props.getReturnDispatchesDailySummary({ date: summaryDate });
    };

    handleChangeDate = (event) => {
        this.setState({ summaryDate: event.target.value }, () => {
            this.fetchDailySummary();
        });
    };

    doRequest = () => {
        const { getReturnDispatchSuppliers } = this.props;
        const { activePage, pageSize, valueSearch } = this.state;

        const params = {
            page_size: pageSize,
            page: activePage
        };

        if (valueSearch !== '') {
            params.query = valueSearch;
        }
        getReturnDispatchSuppliers(params).then(res => {
            if (res.payload) {
                this.setState({ loading: false });
            }
        });
    };

    handleSearch = (e) => {
        if (e.keyCode === 13) {
            this.setState({ activePage: 1 });
            setTimeout(() => {
                this.doRequest();
            }, 0);
        } else if (e === 'iconClick') {
            this.setState({ activePage: 1 });
            setTimeout(() => {
                this.doRequest();
            }, 0);
        }
    };

    changeValueSearch = (e) => {
        this.setState({ valueSearch: e.target.value });
    };

    changePage = (pageNumber) => {
        this.setState({ activePage: pageNumber.selected + 1 });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    };

    changePageSize = (pageSize) => {
        this.setState({ pageSize: Number(pageSize), activePage: 1 });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    };

    handleSupplierClick = (supplierId) => {
        if (supplierId === null || supplierId === undefined) return;

        const supplier = this.props.return_dispatches.return_dispatch_suppliers.results
            .find((item) => item.supplier_id === supplierId);

        this.props.history.push({
            pathname: `/admin/return-dispatches/${supplierId}`,
            state: { supplierName: supplier && supplier.supplier },
        });
    };

    render() {
        const { return_dispatches: { return_dispatch_suppliers, daily_summary } } = this.props;
        const { activePage, pageSize, valueSearch } = this.state;
        if (!return_dispatch_suppliers.results) return null;

        return (
            <TransitionedBlock>
                <div className="return_dispatches container">
                    <div className="flex-center-btw title-block-page">
                        <div className="title-page">
                            <h1>Выдача возвратов</h1>
                        </div>
                        <div className="add_button">
                            <Button
                                component={Link}
                                to="/admin/new-return-dispatch"
                                classes={{
                                    root: 'add_btn'
                                }}
                            >
                                Добавить
                                <img src={AddIcon} alt="add icon"/>
                            </Button>
                        </div>
                    </div>
                    <div className="page_block">
                        <div className="return_dispatches_filters">
                            <div className="filters_left">
                                <div className="search_wrapper search_transactions_panel">
                                    <div className="search_product_wrapper">
                                        <input
                                            type="text"
                                            value={valueSearch}
                                            onKeyDown={(e) => this.handleSearch(e)}
                                            onChange={(e) => this.changeValueSearch(e)}
                                            placeholder="Название поставщика, номер артикула/заказа"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="search_input_icon">
                                        <img
                                            src={SearchIcon}
                                            alt="SearchIcon"
                                            onClick={() => this.handleSearch('iconClick')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="filters_right">
                                {daily_summary && (
                                    <div className="daily_summary_block">
                                        <span className="green_text">
                                            {daily_summary.approved_total_sum !== undefined
                                                ? formatPrice(daily_summary.approved_total_sum)
                                                : '—'}
                                        </span>
                                        {' / '}
                                        <span className="red_text">
                                            {daily_summary.dispatch_total_sum !== undefined
                                                ? formatPrice(daily_summary.dispatch_total_sum)
                                                : '—'}
                                        </span>
                                    </div>
                                )}
                                <div className="summary_date_picker">
                                    <RenderField
                                        id="summary_date"
                                        type="date"
                                        name="summary_date"
                                        placement="start"
                                        meta={{}}
                                        input={{
                                            value: this.state.summaryDate,
                                            defaultValue: today,
                                            onChange: this.handleChangeDate,
                                            size: "small",
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="return_dispatches_table">
                            <div className="table_container transactions_columns">
                                <div className="table_header">
                                    <div className="table_row">
                                        <div className="row_item">Компания</div>
                                        <div className="row_item">Количество</div>
                                        <div className="row_item">Сумма</div>
                                    </div>
                                </div>
                                <div className="table_body">
                                    {return_dispatch_suppliers.results.length !== 0 ? return_dispatch_suppliers.results.map((item) => {
                                        const hasSupplier = item.supplier_id !== null && item.supplier_id !== undefined;

                                        return (
                                            <div
                                                className={`table_row${hasSupplier ? ' table_row_clickable' : ''}`}
                                                key={hasSupplier ? item.supplier_id : 'without-supplier'}
                                                onClick={hasSupplier ? () => this.handleSupplierClick(item.supplier_id) : undefined}
                                            >
                                                <div className="row_item">
                                                    {hasSupplier ? item.supplier : 'Без поставщика'}
                                                </div>
                                                <div className="row_item">{item.pending_amount}</div>
                                                <div className="row_item">{formatPrice(item.pending_sum)}</div>
                                            </div>
                                        );
                                    }) :
                                        <h1 style={{ marginTop: '30px' }}>Записей не найдено</h1>
                                    }
                                </div>
                            </div>
                            <div className='control_panel'>
                                {return_dispatch_suppliers.count && return_dispatch_suppliers.count > pageSize ?
                                    <div>
                                        <Pagination
                                            active={activePage}
                                            pageItemsCount={pageSize}
                                            pageTotalCount={return_dispatch_suppliers.count}
                                            onChange={this.changePage}
                                        />
                                    </div>
                                    : null}
                                <ControlPanel
                                    value={pageSize}
                                    options={[10, 20, 30, 40, 50]}
                                    onChange={(event) => this.changePageSize(event.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <WaitingReturnDispatchSuppliers />
                </div>
            </TransitionedBlock>
        );
    }
}

const mapStateToProps = ({ return_dispatches }) => ({
    return_dispatches
});

const mapDispatchToProps = {
    getReturnDispatchSuppliers,
    getReturnDispatchesDailySummary
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnDispatches);
